<template>
  <div>
    <div class="outdoor-pricelist-ftprice" v-if="!isModalLoading">
      <h1 class="subhead">CONTENT CHANGES</h1>
      <div v-if="contentChangesPrice" class="outdoor-pricelist-ftprice__row">
        <div class="subhead">Content Changes Price per m2</div>
        <h1>{{ formatPrice(contentChangesPrice) }}</h1>
      </div>
      <div v-if="contentChangesQuota" class="outdoor-pricelist-ftprice__row">
        <div class="subhead">Content Changes Quota</div>
        <h1>{{ pluralize(contentChangesQuota, 'Change') }}</h1>
      </div>
      <h1 class="subhead">FUTURE PRICE</h1>
      <adx-table v-if="items.body.length > 0" :items.sync="items" :isEmpty.sync="isEmpty"></adx-table>
      <span v-else class="color-grey">This item doesn't have any future price right now</span>
    </div>
    <a-loading v-else />
  </div>
</template>

<script>
import api from "@/api";
import { restEdge } from "@/api/edgeUrls";
import moment from "moment";

import table from "@/components/Table";

import { ALoadingPrimary } from "ui-kit-v1";

export default {
  name: "adx-outdoor-placement-ftprice",
  components: {
    "adx-table": table,
    "a-loading": ALoadingPrimary
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      items: {
        head: [
          {
            title: "START ON",
            type: "text"
          },
          {
            title: "PUBLIC PRICE",
            type: "money"
          }
        ],
        body: []
      },
      isEmpty: false,
      contentChangesPrice: 0,
      contentChangesQuota: 0
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async loadData() {
      this.isModalLoading = true;
      this.isEmpty = false;
      const { data, status } = await api.get(
        restEdge.outdoorPricelistDetail(this.placementId),
        { needToken: true, useRestEdge: true }
      );

      if (status === 200) {
        if (data.future_prices.length)
          this.items.body = data.future_prices.map(future => ({
            values: [
              {
                value: moment(future.start)
                  .utcOffset(7)
                  .format("DD MMM YYYY")
              },
              {
                value: future.public_price
              }
            ]
          }));

        if (!this.items.body.length) this.isEmpty = true;

        this.contentChangesPrice = data.location.change_content_price;
        this.contentChangesQuota = data.max_change_content;
      }

      this.isModalLoading = false;
    },
    pluralize(value, label) {
      if (value > 1) {
        return `${value} ${label}s`;
      }
      return `${value} ${label}`;
    },
    formatPrice(price) {
      if (price == 0) return 0;
      let strPrice = price.toString();
      let arrayPrice = strPrice.split("");
      let revArrayPrice = arrayPrice.reverse();
      let newPrice = [];
      revArrayPrice.forEach((value, index) => {
        newPrice.push(value);
        if ((index + 1) % 3 == 0 && index + 1 != revArrayPrice.length) {
          newPrice.push(".");
        }
      });
      return "Rp " + newPrice.reverse().join("");
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>

<style lang='scss'>
</style>